import { useEffect } from 'react'

const TAWK_SRC = 'https://embed.tawk.to/680aec3922d1d91910dd2149/1iplalgrv'

/** Carga el widget de chat en vivo de Tawk.to una sola vez. */
export function useTawkTo(): void {
  useEffect(() => {
    if (document.querySelector(`script[src="${TAWK_SRC}"]`)) return

    const w = window as unknown as Record<string, any>
    w.Tawk_API = w.Tawk_API || {}
    w.Tawk_LoadStart = new Date()

    // Posiciona el widget abajo a la izquierda en desktop y móvil.
    w.Tawk_API.customStyle = {
      visibility: {
        desktop: { position: 'bl', xOffset: 20, yOffset: 20 },
        mobile: { position: 'bl', xOffset: 10, yOffset: 10 },
      },
    }

    const script = document.createElement('script')
    script.async = true
    script.src = TAWK_SRC
    script.charset = 'UTF-8'
    script.setAttribute('crossorigin', '*')
    document.body.appendChild(script)
  }, [])
}
